/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TagManager from 'react-gtm-module';
import $ from 'jquery';
function PersonalInformationProtection(props) {
	if (props.data !== null || props.data !== ""){
		var info = props.data
		if (props.data.includes("@")){
			var secComponentData = props.data.split("@")[1]
			var thirdComponentData = secComponentData.split(".")[1]
			return props.data.substring(0,2) + "***@" + secComponentData.substring(0,1) + "***." +  thirdComponentData
		}else if (/^\d+$/.test(props.data)){
			
			if (info.length === 10){
				return info.substring(0,4) + "*" + info.substring(5,6) + "*" + info.substring(7,8) + "*" + info.substring(9,10)
			}
		}else if (props.data.toString().match(/[\u3400-\u9FBF]/)){
			
			var result = ""
			for (let i=0; i < info.length; i++){
				if (i===0 || i === info.length-1){
					result += info[i] 
				}else{
					result += "o"
				}
					
			}
			return result
		}
	}else{
		return <></>
	}
}
function CommodityPlan() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	useEffect(() => {
		$(".btn_popup").on('click', function () {
			$(".popup").hide();
			var href = "#" + $(this).attr('id');
			$(href).show();
		})
		$(".btn_close").on('click', function () {
			$(".popup").hide();
		});
	}, [location])
	return (
		<>
			<div className="popup" id="cd_pop02">
				<div className="pagesize">
					<div className="popup_box commodity_txt">
						<a className="btn_close"> </a>
						<div className="popup_txt">
							<div className="cob_box flex_set">
								<div className="cob_txt flex_box">
									<h4>[入門款]LUCIA mini 選購說明</h4>
									<h5>單機購買</h5>
									<p>「6個月免費體驗」係指單機購買音箱且113/3/31前於APP線上啟用i寶貝服務，享免費體驗6個月，體驗期內可隨時退租不收費，每台音箱僅限一次。體驗期滿未退租則視為客戶繼續租用，每月依i寶貝智慧聲控服務牌告價收費99元/月。</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cd_pop04">
				<div className="pagesize">
					<div className="popup_box commodity_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cob_box flex_set">
								<div className="cob_txt flex_box">
									<h4>[入門款]LUCIA mini 選購說明</h4>
									<h5>行動4G/5G方案</h5>
									<ul className="list_sty">
										<li>除音箱費用外，每月需另付i寶貝智慧聲控服務月租費99元，行動4G/5G、光世代月租費(依牌告價計收)。</li>
										<li>上述方案適用對象：新申請/升速/原速續約HiNet光世代(非固定制)客戶；新申請/續約/攜碼行動4G/5G客戶。</li>
										<li>參加上述優惠方案需同時租用i寶貝智慧聲控服務及行動4G/5G或光世代100M(含)以上，並依所選方案綁約24/30/36個月，中途不可轉換至其他方案，未滿租期退租任一服務，須繳交提前解約金。</li>
										<li>詳細方案內容及適用條件以中華電信門市公告為準，本公司保留隨時修改或終止本方案之權利。</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cd_pop05">
				<div className="pagesize">
					<div className="popup_box commodity_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cob_box flex_set">
								<div className="cob_txt flex_box">
									<h4>[入門款]LUCIA mini 選購說明</h4>
									<h5>HiNet光世代</h5>
									<ul className="list_sty">
										<li>除音箱費用外，須另申租i寶貝智慧聲控服務(月租99元)，光世代月租費(依牌告價計收)。如為HiNet光世代300M(含)以上速率搭配LUCIA mini音箱，則加贈i寶貝智慧聲控服務(月租0元)，合約到期後未退租本方案，可續享優惠。</li>
										<li>上述方案適用對象：新申請/升速/原速續約HiNet光世代(非固定制)客戶。</li>
										<li>參加上述優惠方案綁約24個月，中途不可轉換至其他方案，未滿租期退租任一服務，須繳交提前解約金。</li>
										<li>詳細方案內容及適用條件以中華電信門市公告為準，本公司保留隨時修改或終止本方案之權利。</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cd_pop06">
				<div className="pagesize">
					<div className="popup_box commodity_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cob_box flex_set">
								<div className="cob_txt flex_box">
									<h4>MOD聲控遙控器+[入門款]LUCIA mini 選購說明</h4>
									<h5>智慧家庭聲控方案</h5>
									<ul className="list_sty">
										<li>上述方案適用對象：新申請/既有MOD客戶。僅限中華電信直營門市受理，不開放神腦特約服務中心、網路門市、客服專線申辦。</li>
										<li>申租本方案月租費99元(已含i寶貝智慧聲控服務)，MOD遙控器將升級為聲控版，並加贈LUCIA mini智慧音箱，合約到期後未退租本方案，可續享月租優惠。</li>
										<li>參加上述優惠方案綁約24個月，中途不可轉換至其他方案，未滿租期退租任一服務，須繳交提前解約金。</li>
										<li>詳細方案內容及適用條件以中華電信門市公告為準，本公司保留隨時修改或終止本方案之權利。</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/commodity">商品專區</a></li>
					</ul>
					<div className="tab_con">
						<div className="tab_box active">
							<h2 className="tit_main">
							商品專區-優惠方案
							<div className="kv">
								<img className="d-none d-lg-block double_day_banner" src={require("../../image/DoubleDay_1280x500.jpg").default} alt="DoubleDay"></img>
								<img className="d-lg-none d-lg-block double_day_banner" src={require("../../image/DoubleDay_750x600.jpg").default} alt="DoubleDay"></img>
							</div>
							<p style={{"color": "#313131"}}>
								1.活動名稱：i寶貝-『DoubleDay』快閃活動<br/>
								2.適用對象：i寶貝新客戶<br/>
								3.活動期間：113/01/11~113/01/20<br/>
								4.活動方式：快閃期間，當筆同時申購i寶貝智慧音箱+聲控服務，就送「勁爽加量包1GB行動上網流量券」(市值180元)，於活動後次月月底前統一簡訊發送，不另行公告，效期至2024/07/31，逾期失效。使用規則與說明詳
								<a style={{"display":"inline"}} href="https://www.cht.com.tw/home/consumer/mobservice/basic/803" target="_blank" rel="noreferrer">https://www.cht.com.tw/home/consumer/mobservice/basic/803</a><br/>
								註1：112/12/1~12/31 i寶貝年終大回饋『有buy有ibobby』活動已結束，活動贈送之「HamiPoint300點」，兌點序號於活動後次月月底前統一簡訊發送，可至中華會員中心序號兌點
								<a style={{"display":"inline"}} href="https://my.cht.com.tw/" target="_blank" rel="noreferrer">https://my.cht.com.tw/</a>
								，不另行公告，點數效期至2024/12/31，逾期失效。<br/>
								註2：本活動參加資格需於名單統計前未退租且不含以下對象：699購機方案、中華電信門市展示機、測試機。<br/>
								註3：填寫產品申請書時，若未填行動電話，以至於系統作業上無法撈取，視同放棄。
							</p>
							</h2>
							<div className="content_box discount_box">

								<div id="buy"></div>
								<div className="table_box show_web">
									<table border="0" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<th width="25%">項目</th>
											<th>[入門款]LUCIA mini</th>
										</tr>
										<tr>
											<th className="sty02"></th>
											<th colSpan="2" className="sty02">單機購買<span>啟用i寶貝智慧聲控(內建KKBOX音樂服務)享6個月免費體驗。</span></th>
										</tr>
										<tr>
											<th className="sty01">直購價格</th>
											<td>音箱<span className="txt_blue txt_bold">1,990</span>元<a href="https://www.hamimall.com.tw/order.php?id=300734" target="_blank" className="btn_pick" rel="noreferrer">選購方案</a>
												<a id="cd_pop02" className="btn_more btn_popup">選購說明</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
								<div className="table_box show_mobile">
									<table border="0" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<th width="50%">項目</th>
											<th width="50%">LUCIA Mini</th>
										</tr>
										<tr>
											<th colSpan="2" className="sty02">單機購買<span>啟用i寶貝智慧聲控(內建KKBOX音樂服務)享6個月免費體驗。</span></th>
										</tr>
										<tr>
											<th className="sty01">直購價格</th>
											<td>音箱<span className="txt_blue txt_bold">1,990</span>元</td>
										</tr>
										<tr>
											<td colSpan="2">
												<a href="https://www.hamimall.com.tw/order.php?id=300734" className="btn_pick" target="_blank" rel="noreferrer">選購方案</a>
												<a id="cd_pop02" className="btn_more btn_popup">選購說明</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div>

								<div id="mobile"></div>
								<div className="table_box show_web">
									<table border="0" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<th width="25%">項目</th>
											<th>[入門款]LUCIA mini</th>
										</tr>
										<tr>
											<th className="sty02"></th>
											<th colSpan="2" className="sty02">行動 4G/5G 方案<span>同時申租i寶貝智慧聲控(內建KKBOX音樂服務)</span></th>
										</tr>
										<tr>
											<th className="sty01">大 4G 行動方案</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<th className="sty01">青春無敵學生方案</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<th className="sty01">699 購機方案</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<th className="sty01">精采 5G 方案</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<td></td>
											<td>
												<a href="https://www.cht.com.tw/home/consumer/mobservice/device/smart-home/000900002635#color:C12208089133" target="_blank" className="btn_pick" rel="noreferrer">選購方案</a>
												<a id="cd_pop04" className="btn_more btn_popup" >選購說明</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
								<div className="table_box show_mobile">
									<table border="0" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<th width="50%">項目</th>
											<th width="50%">LUCIA Mini</th>
										</tr>
										<tr>
											<th colSpan="2" className="sty02">行動 4G/5G 方案<span>同時申租i寶貝智慧聲控(內建KKBOX音樂服務)</span></th>
										</tr>
										<tr>
											<th className="sty01">大 4G 行動方案</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<th className="sty01">青春無敵學生方案</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<th className="sty01">699 購機方案</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<th className="sty01">精采 5G 方案</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<td colSpan="2">
												<a href="https://www.cht.com.tw/home/consumer/mobservice/device/smart-home/000900002635#color:C12208089133" className="btn_pick" target="_blank" rel="noreferrer">選購方案</a>
												<a id="cd_pop04" className="btn_more btn_popup">選購說明</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div>

								{/*<div id="HiNet"></div>
								<div className="table_box show_web">
									<table border="0" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<th width="25%">項目</th>
											<th>[入門款]LUCIA mini</th>
										</tr>
										<tr>
											<th className="sty02"></th>
											<th colSpan="2" className="sty02">HiNet 光世代<span>同時申租i寶貝智慧聲控(內建KKBOX音樂服務)</span></th>
										</tr>
										<tr>
											<th className="sty01">光世代 100M(含)</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<th className="sty01">光世代 300M以上</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<td></td>
											<td>
												<a href="https://www.cht.com.tw/home/campaign/broadbandgift/index.html" target="_blank" className="btn_pick" rel="noreferrer">選購方案</a>
												<a id="cd_pop05" className="btn_more btn_popup">選購說明</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
								<div className="table_box show_mobile">
									<table border="0" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<th width="50%">項目</th>
											<th width="50%">LUCIA Mini</th>
										</tr>
										<tr>
											<th colSpan="2" className="sty02">HiNet 光世代<span>同時申租i寶貝智慧聲控(內建KKBOX音樂服務)</span></th>
										</tr>
										<tr>
											<th className="sty01">光世代 100M(含)</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<th className="sty01">光世代 300M以上</th>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<td colSpan="2">
												<a href="https://www.cht.com.tw/home/campaign/broadbandgift/index.html" className="btn_pick" target="_blank" rel="noreferrer">選購方案</a>
												<a id="cd_pop05" className="btn_more btn_popup">選購說明</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div> */}

								{/*<div id="mod"></div>
								<div className="table_box show_web">
									<table border="0" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr id="mod">
											<th width="25%">項目</th>
											<th colSpan="2">MOD聲控遙控器+[入門款]LUCIA mini</th>
										</tr>
										<tr>
											<th className="sty02"></th>
											<th colSpan="2" className="sty02">智慧家庭聲控方案(內建i寶貝智慧聲控服務，月租99元)</th>
										</tr>
										<tr>
											<th className="sty01">MOD用戶</th>
											<td>聲控遙控器<span className="txt_blue txt_bold">0</span>元</td>
											<td>音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<td></td>
											<td colSpan="2">
												<a className="btn_pick" href="/container/mod2" target="_blank">了解更多</a>
												<a id="cd_pop06" className="btn_more btn_popup">選購說明</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
								<div className="table_box show_mobile">
									<table border="0" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<th width="50%">項目</th>
											<th width="50%">MOD聲控遙控器+LUCIA mini</th>
										</tr>
										<tr>
											<th colSpan="2" className="sty02">智慧家庭聲控方案(內建i寶貝智慧聲控服務，月租99元)</th>
										</tr>
										<tr>
											<th className="sty01">MOD用戶</th>
											<td>聲控遙控器<span className="txt_blue txt_bold">0</span>元<br />音箱<span className="txt_orange txt_bold">0</span>元</td>
										</tr>
										<tr>
											<td colSpan="2">
												<a className="btn_pick" href="/container/mod2" target="_blank">了解更多</a>
												<a id="cd_pop06" className="btn_more btn_popup">選購說明</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div>*/}

								<div className="btn_main"><a href="https://www.cht.com.tw/home/cht/about-cht/business-group/store-locator" target="_blank" rel="noreferrer">申辦洽中華門市</a></div>
								<div className="remark">
									<p>單機購買、行動4G/5G方案亦可至神腦特約服務中心辦理。</p>
									<p>客服專線：0800-080-123 (中華市話、行動直撥123)。</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default CommodityPlan;